import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { setReset } from 'redux/actions';
import { useCallback } from 'react';
import { servicesAuth } from '../services';

const useLogOut = () => {
    const dispatch = useDispatch();
    return useCallback(async () => {
        dispatch(setReset());
        toast.success('Logged out success');
        window.localStorage.clear();
        await servicesAuth.logOut();
    }, [dispatch]);
};
export default useLogOut;
